import { Sparkles, ShieldCheck, Clock } from "lucide-react";
import { Shell, StepFooter } from "@/components/Shell";

export function Welcome({ onStart }) {
  return (
    <Shell showProgress={false}>
      <div className="pt-6">
        <span className="cc-eyebrow">Bienvenida</span>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight mt-3 text-[hsl(var(--texto))]">
          Entender tus síntomas es un buen primer paso
        </h1>
        <p className="mt-5 text-lg text-[hsl(var(--muted-foreground))] leading-relaxed">
          Climaterio Claro te ayuda a organizar lo que estás sintiendo y reconocer
          cuándo conviene solicitar valoración médica.
        </p>

        <div className="mt-8 space-y-3">
          <Feature
            icon={<Clock className="h-5 w-5" />}
            title="Toma unos minutos"
            desc="Un cuestionario breve, una sección por pantalla."
          />
          <Feature
            icon={<ShieldCheck className="h-5 w-5" />}
            title="Sin cuentas ni datos personales"
            desc="Todo se procesa en tu navegador y se borra al recargar."
          />
          <Feature
            icon={<Sparkles className="h-5 w-5" />}
            title="Orientación, no diagnóstico"
            desc="Te ayuda a preparar mejor tu consulta médica."
          />
        </div>
      </div>

      <StepFooter>
        <div />
        <button
          onClick={onStart}
          className="cc-btn-primary w-full sm:w-auto"
          data-testid="welcome-start-btn"
        >
          Comenzar
        </button>
      </StepFooter>
    </Shell>
  );
}

function Feature({ icon, title, desc }) {
  return (
    <div className="cc-card p-4 flex gap-4 items-start">
      <div className="h-10 w-10 rounded-full bg-[hsl(var(--arena))] flex items-center justify-center text-[hsl(var(--olivo))] shrink-0">
        {icon}
      </div>
      <div>
        <h3 className="font-serif text-lg leading-snug">{title}</h3>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{desc}</p>
      </div>
    </div>
  );
}
